import { createApp } from "vue";
import App from "../App.vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// 在此直接进行挂载pinia：参考文章https://blog.csdn.net/jsmeng626/article/details/129835207
app.use(pinia);

// 此处暂时是抛出给main.ts进行挂载，全局注册
export default pinia;